import api from 'Application/api/api';

const deleteInstruction = (id, cancelToken = null) =>
    api.delete(`/education/instructions/${id}`, { cancelToken });

export default deleteInstruction;
